import useMinWidth from '@/hooks/useMinWidth'

export function useIsMinWidth2xl() {
  return useMinWidth('2xl')
}
